<template>
  <div class="jobmanager-container">
    <div class="leftSider"><img src="@assets/leftSider.png" alt=""></div>
    <div class="rightSider"><img src="@assets/rightSider.png" alt=""></div>

    <dp-header :title="'作业管理'"></dp-header>

    <!-- 密钥验证遮罩 -->
    <div v-if="!authenticated" class="auth-gate">
      <div class="auth-card">
        <div class="auth-icon"><i class="el-icon-lock"></i></div>
        <div class="auth-title">访问受限</div>
        <div class="auth-desc">此页面仅供管理员使用，请输入访问密钥</div>
        <el-input
          v-model="inputKey"
          type="password"
          placeholder="请输入访问密钥"
          show-password
          @keyup.enter.native="verifyKey"
          style="margin-bottom:12px"
        />
        <div v-if="authError" class="auth-error">密钥错误，请重试</div>
        <el-button type="primary" @click="verifyKey" style="width:100%">确认</el-button>
      </div>
    </div>

    <!-- 主内容 -->
    <div v-else class="main-content">
      <!-- 统计行 -->
      <div class="job-stats-bar" v-loading="jobStatsLoading">
        <div class="job-stat-item"><b>{{ jobStats.total }}</b><span>总任务</span></div>
        <div class="job-stat-sep"></div>
        <div class="job-stat-item"><b>{{ jobStats.pending }}</b><span>待执行</span></div>
        <div class="job-stat-sep"></div>
        <div class="job-stat-item"><b>{{ jobStats.running }}</b><span>执行中</span></div>
        <div class="job-stat-sep"></div>
        <div class="job-stat-item"><b>{{ jobStats.success }}</b><span>成功</span></div>
        <div class="job-stat-sep"></div>
        <div class="job-stat-item"><b>{{ jobStats.failure }}</b><span>失败</span></div>
        <div class="job-stat-sep"></div>
        <div class="job-stat-item"><b>{{ jobStats.cancelled }}</b><span>取消</span></div>
        <div class="job-stat-sep"></div>
        <div class="job-stat-item"><b>{{ jobStats.completed_today }}</b><span>今日完成</span></div>
      </div>

      <!-- 任务列表 -->
      <div class="section-card">
        <div class="job-list-header">
          <span class="card-title" style="margin-bottom:0;border-bottom:none;padding-bottom:0">任务列表</span>
          <div class="job-list-filters">
            <el-select v-model="jobFilterStatus" placeholder="全部状态" clearable size="small" style="width:110px" @change="loadJobList(1)">
              <el-option label="待执行" value="pending" />
              <el-option label="执行中" value="running" />
              <el-option label="成功" value="success" />
              <el-option label="失败" value="failure" />
              <el-option label="已取消" value="cancelled" />
            </el-select>
            <el-select v-model="jobFilterServer" placeholder="全部服务器" clearable size="small" style="width:120px" @change="loadJobList(1)">
              <el-option v-for="w in knownWorkers" :key="w" :label="w" :value="w" />
            </el-select>
            <el-button size="small" @click="loadJobList(1)"><i class="el-icon-refresh"></i> 刷新</el-button>
            <el-button type="primary" size="small" @click="openSubmitDialog"><i class="el-icon-plus"></i> 提交任务</el-button>
          </div>
        </div>

        <el-table :data="jobList" size="mini" v-loading="jobListLoading" style="margin-top:12px">
          <el-table-column label="任务ID" width="100">
            <template slot-scope="scope">
              <span class="job-id-text" :title="scope.row.task_id">{{ scope.row.task_id.slice(0,8) }}...</span>
            </template>
          </el-table-column>
          <el-table-column label="来源列表" min-width="120">
            <template slot-scope="scope">
              <span class="scan-task-runid">{{ (scope.row.params && scope.row.params.source_lists && scope.row.params.source_lists.join(', ')) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务器" prop="server_id" width="90"></el-table-column>
          <el-table-column label="Stage" width="115">
            <template slot-scope="scope">
              <el-tag :type="taskTypeTag(scope.row.task_type)" size="mini">{{ taskTypeLabel(scope.row.task_type) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="jobStatusTag(scope.row.status)" size="mini">{{ jobStatusLabel(scope.row.status) }}</el-tag>
              <el-tag v-if="scope.row.worker_stale" type="danger" size="mini" style="margin-top:2px"
                title="该任务仍处于执行中，但所属 Worker 心跳已超时，可能已失联，等待自动回收续跑">⚠失联</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="进度" width="150">
            <template slot-scope="scope">
              <template v-if="scope.row.status === 'running'">
                <el-progress :percentage="scope.row.progress || 0" :stroke-width="6" :show-text="false"></el-progress>
                <div class="job-step-text" :title="scope.row.current_step">{{ checkpointText(scope.row) }}</div>
              </template>
              <span v-else class="job-step-text">{{ scope.row.current_step || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优先级" prop="priority" width="70" align="center"></el-table-column>
          <el-table-column label="batch_id" width="120">
            <template slot-scope="scope">
              <span class="scan-task-runid">{{ (scope.row.params && scope.row.params.batch_id) || (scope.row.params && scope.row.params.run_id) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="run_id" width="120">
            <template slot-scope="scope">
              <span class="scan-task-runid">{{ (scope.row.params && scope.row.params.run_id) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="source_run_id" width="120">
            <template slot-scope="scope">
              <span class="scan-task-runid">{{ (scope.row.params && scope.row.params.source_run_id) || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="130">
            <template slot-scope="scope">{{ fmtTime(scope.row.created_at) }}</template>
          </el-table-column>
          <el-table-column label="完成时间" width="130">
            <template slot-scope="scope">{{ fmtTime(scope.row.completed_at) }}</template>
          </el-table-column>
          <el-table-column label="探测用时" width="80">
            <template slot-scope="scope">{{ fmtElapsed(scope.row.result && scope.row.result.probe_elapsed) }}</template>
          </el-table-column>
          <el-table-column label="上传用时" width="80">
            <template slot-scope="scope">{{ fmtElapsed(scope.row.result && scope.row.result.upload_elapsed) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 'pending' || scope.row.status === 'running'"
                type="text" size="mini" style="color:#f87171"
                @click="cancelJob(scope.row.task_id)"
              >取消</el-button>
              <span v-else class="job-step-text">-</span>
            </template>
          </el-table-column>
        </el-table>

        <div style="margin-top:12px;text-align:right">
          <el-pagination
            :current-page="jobPage" :page-size="jobSize" :total="jobTotal"
            layout="total, prev, pager, next" @current-change="loadJobList"
          />
        </div>
      </div>

      <!-- 定时任务 -->
      <div class="section-card">
        <div class="job-list-header">
          <span class="card-title" style="margin-bottom:0;border-bottom:none;padding-bottom:0">定时任务</span>
          <el-button type="primary" size="small" @click="openScheduleDialog"><i class="el-icon-plus"></i> 新建定时任务</el-button>
        </div>

        <el-table :data="scheduleList" size="mini" v-loading="scheduleLoading" style="margin-top:12px">
          <el-table-column label="名称" prop="name" min-width="120"></el-table-column>
          <el-table-column label="Stage" width="115">
            <template slot-scope="scope">
              <el-tag :type="taskTypeTag(scope.row.task_type || 'passive_probe')" size="mini">{{ taskTypeLabel(scope.row.task_type || 'passive_probe') }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="列表" min-width="120">
            <template slot-scope="scope">{{ (scope.row.lists || []).join(', ') }}</template>
          </el-table-column>
          <el-table-column label="source_run_id" width="120">
            <template slot-scope="scope"><span class="scan-task-runid">{{ scope.row.source_run_id || '-' }}</span></template>
          </el-table-column>
          <el-table-column label="Cron 表达式" prop="cron" width="130">
            <template slot-scope="scope">
              <span class="scan-task-runid">{{ scope.row.cron }}</span>
            </template>
          </el-table-column>
          <el-table-column label="优先级" prop="priority" width="70" align="center"></el-table-column>
          <el-table-column label="状态" width="80">
            <template slot-scope="scope">
              <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="mini">{{ scope.row.enabled ? '启用' : '停用' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="上次触发" width="130">
            <template slot-scope="scope">{{ fmtTime(scope.row.last_triggered_at) }}</template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="triggerSchedule(scope.row)">立即触发</el-button>
              <el-button type="text" size="mini" @click="toggleScheduleEnabled(scope.row)">{{ scope.row.enabled ? '停用' : '启用' }}</el-button>
              <el-button type="text" size="mini" style="color:#f87171" @click="deleteSchedule(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 提交任务弹窗 -->
    <el-dialog title="提交扫描任务" :visible.sync="submitDialogVisible" width="480px" custom-class="job-dialog">
      <el-form :model="submitForm" label-width="90px" size="small">
        <el-form-item label="Stage">
          <el-select v-model="submitForm.task_type" style="width:100%">
            <el-option label="Passive probe" value="passive_probe" />
            <el-option label="Active reverify" value="active_reverify" />
            <el-option label="NS backfill" value="ns_backfill" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="submitForm.task_type === 'passive_probe'" label="Lists">
          <el-checkbox-group v-model="submitForm.lists">
            <el-checkbox v-for="l in availableLists" :key="l" :label="l">{{ l }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-else label="Source run">
          <el-input v-model="submitForm.source_run_id" placeholder="Original passive_probe run_id, e.g. 202605020300" />
        </el-form-item>
        <el-form-item label="优先级">
          <el-slider v-model="submitForm.priority" :min="1" :max="10" show-stops></el-slider>
        </el-form-item>
        <el-form-item label="run_id">
          <el-input v-model="submitForm.run_id" placeholder="Leave empty for auto run_id; rv/nb defaults use source_run_id" />
        </el-form-item>
        <el-form-item v-if="submitForm.task_type === 'passive_probe' || submitForm.task_type === 'ns_backfill'" label="Collect conc.">
          <el-input-number v-model="submitForm.concurrency" :min="1" :max="1000" style="width:100%" />
        </el-form-item>
        <el-form-item v-if="submitForm.task_type === 'passive_probe' || submitForm.task_type === 'active_reverify'" label="Risk conc.">
          <el-input-number v-model="submitForm.risk_concurrency" :min="1" :max="500" style="width:100%" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="submitDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="submitLoading" @click="doSubmitTask">提交</el-button>
      </span>
    </el-dialog>

    <!-- 新建定时任务弹窗 -->
    <el-dialog title="新建定时任务" :visible.sync="scheduleDialogVisible" width="480px" custom-class="job-dialog">
      <el-form :model="scheduleForm" label-width="90px" size="small">
        <el-form-item label="任务名称">
          <el-input v-model="scheduleForm.name" placeholder="如：每日全量扫描" />
        </el-form-item>
        <el-form-item label="Stage">
          <el-select v-model="scheduleForm.task_type" style="width:100%">
            <el-option label="Pipeline full rebuild" value="pipeline" />
            <el-option label="Passive probe" value="passive_probe" />
            <el-option label="Active reverify" value="active_reverify" />
            <el-option label="NS backfill" value="ns_backfill" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="scheduleForm.task_type === 'passive_probe' || scheduleForm.task_type === 'pipeline'" label="Lists">
          <el-checkbox-group v-model="scheduleForm.lists">
            <el-checkbox v-for="l in availableLists" :key="l" :label="l">{{ l }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-else label="Source run">
          <el-input v-model="scheduleForm.source_run_id" placeholder="Optional: empty uses next unprocessed passive run" />
        </el-form-item>
        <el-form-item label="Cron 表达式">
          <el-input v-model="scheduleForm.cron" placeholder="如 0 2 * * *（每天凌晨2点，UTC）" />
          <div style="font-size:11px;color:#4a6a8a;margin-top:4px">标准5字段 cron：分 时 日 月 周（UTC时间）</div>
        </el-form-item>
        <el-form-item label="优先级">
          <el-slider v-model="scheduleForm.priority" :min="1" :max="10" show-stops></el-slider>
        </el-form-item>
        <template v-if="scheduleForm.task_type === 'pipeline'">
          <el-divider content-position="left">Pipeline 参数</el-divider>
          <el-form-item label="Passive chunk size">
            <el-input-number v-model="scheduleForm.passive_options.chunk_size" :min="1" :step="1000" controls-position="right" style="width:100%" />
          </el-form-item>
          <el-form-item label="Active chunk size">
            <el-input-number v-model="scheduleForm.active_options.chunk_size" :min="1" :step="1000" controls-position="right" style="width:100%" />
          </el-form-item>
          <el-form-item label="Active risk concurrency">
            <el-input-number v-model="scheduleForm.active_options.risk_concurrency" :min="1" controls-position="right" style="width:100%" />
          </el-form-item>
          <el-form-item label="NS chunk size">
            <el-input-number v-model="scheduleForm.ns_backfill_options.chunk_size" :min="1" :step="1000" controls-position="right" style="width:100%" />
          </el-form-item>
          <el-form-item label="NS concurrency">
            <el-input-number v-model="scheduleForm.ns_backfill_options.concurrency" :min="1" controls-position="right" style="width:100%" />
          </el-form-item>
        </template>
        <el-form-item label="启用">
          <el-switch v-model="scheduleForm.enabled" active-color="#1890ff"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="scheduleDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" :loading="scheduleSubmitLoading" @click="doCreateSchedule">创建</el-button>
      </span>
    </el-dialog>

    <navigation></navigation>
  </div>
</template>

<script>
import axiosLib from "axios";
import Navigation from "@/components/navigation.vue";
import DpHeader from "@/components/dp-header.vue";
import {clearDashboardAuth, clearJobManagerAuth, getDashboardToken, JOB_MANAGER_TOKEN_KEY} from "@/utils/dashboardAuth";

// 独立 axios 实例，不受全局拦截器影响（全局拦截器会把非200状态码的响应体 status 字段误判为错误）
const axios = axiosLib.create();
const TOKEN_KEY = JOB_MANAGER_TOKEN_KEY;

axios.interceptors.request.use(config => {
  const dashboardToken = getDashboardToken();
  const token = sessionStorage.getItem(TOKEN_KEY);

  config.headers = config.headers || {};
  if (dashboardToken) {
    config.headers["X-Dashboard-Token"] = dashboardToken;
  }
  if (token) {
    config.headers["X-Jobmanager-Token"] = token;
  }
  return config;
});

axios.interceptors.response.use(
  res => res,
  err => {
    if (err && err.response && err.response.status === 401) {
      const code = err.response.data && err.response.data.code;

      if (code === "DASHBOARD_UNAUTHORIZED") {
        clearDashboardAuth();
        window.location.href = `/login?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}`;
      } else {
        clearJobManagerAuth();
        window.dispatchEvent(new Event("jobmanager-auth-expired"));
      }
    }
    return Promise.reject(err);
  }
);

export default {
  name: "JobManager",
  components: { Navigation, DpHeader },
  data() {
    return {
      authenticated: Boolean(sessionStorage.getItem(TOKEN_KEY)),
      inputKey: "",
      authError: false,
      jobStats: { total: 0, pending: 0, running: 0, success: 0, failure: 0, cancelled: 0, completed_today: 0 },
      jobStatsLoading: false,
      jobList: [],
      jobTotal: 0,
      jobPage: 1,
      jobSize: 15,
      jobFilterStatus: "",
      jobFilterServer: "",
      jobListLoading: false,
      availableLists: ["tranco", "secrank", "cloudflare", "edugov", "company"],
      knownWorkers: [],
      submitDialogVisible: false,
      submitForm: {
        task_type: "passive_probe",
        lists: [],
        priority: 5,
        run_id: "",
        source_run_id: "",
        concurrency: 300,
        risk_concurrency: 50
      },
      submitLoading: false,
      scheduleList: [],
      scheduleLoading: false,
      scheduleDialogVisible: false,
      scheduleForm: {
        name: "",
        task_type: "pipeline",
        lists: [],
        source_run_id: "",
        cron: "0 2 * * *",
        priority: 5,
        enabled: true,
        passive_options: { chunk_size: 20000 },
        active_options: { chunk_size: 5000, risk_concurrency: 30 },
        ns_backfill_options: { chunk_size: 5000, concurrency: 100 }
      },
      scheduleSubmitLoading: false,
      pollingTimer: null
    };
  },
  mounted() {
    window.addEventListener("jobmanager-auth-expired", this.handleAuthExpired);
    if (this.authenticated) {
      this.loadAll();
    }
  },
  beforeDestroy() {
    window.removeEventListener("jobmanager-auth-expired", this.handleAuthExpired);
    this.stopPolling();
  },
  methods: {
    defaultSubmitForm() {
      return {
        task_type: "passive_probe",
        lists: [],
        priority: 5,
        run_id: "",
        source_run_id: "",
        concurrency: 300,
        risk_concurrency: 50
      };
    },
    defaultScheduleForm() {
      return {
        name: "",
        task_type: "pipeline",
        lists: [],
        source_run_id: "",
        priority: 5,
        cron: "0 2 * * *",
        enabled: true,
        passive_options: { chunk_size: 20000 },
        active_options: { chunk_size: 5000, risk_concurrency: 30 },
        ns_backfill_options: { chunk_size: 5000, concurrency: 100 }
      };
    },
    taskTypeLabel(type) {
      const map = { pipeline: "Pipeline", passive_probe: "Passive", active_reverify: "Active", ns_backfill: "NS Backfill" };

      return map[type] || type || "-";
    },
    taskTypeTag(type) {
      const map = { pipeline: "danger", passive_probe: "success", active_reverify: "warning", ns_backfill: "info" };

      return map[type] || "";
    },
    handleAuthExpired() {
      this.stopPolling();
      this.authenticated = false;
      this.authError = false;
    },
    async verifyKey() {
      try {
        const res = await axios.post("/jobmanager/auth/login", { key: this.inputKey }, { timeout: 8000 });
        const token = res.data && res.data.token;

        if (!token) {
          throw new Error("empty token");
        }
        sessionStorage.setItem(TOKEN_KEY, token);
        this.authenticated = true;
        this.authError = false;
        this.inputKey = "";
        this.$nextTick(() => this.loadAll());
      } catch (e) {
        sessionStorage.removeItem(TOKEN_KEY);
        this.authenticated = false;
        this.authError = true;
      }
    },
    loadAll() {
      this.loadJobStats();
      this.loadJobList(1);
      this.loadScheduleList();
      this.loadWorkers();
      this.loadAvailableLists();
      this.startPolling();
    },
    startPolling() {
      if (this.pollingTimer) {
        return;
      }
      this.pollingTimer = setInterval(() => {
        this.loadJobStats();
        this.loadJobList(this.jobPage);
      }, 10000);
    },
    stopPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer); this.pollingTimer = null;
      }
    },
    async loadJobStats() {
      this.jobStatsLoading = true;
      try {
        const res = await axios.get("/celery-api/stats", { timeout: 8000 });

        this.jobStats = res.data;
      } catch (e) {
        console.warn("[jobmanager] stats 加载失败", e.message);
      } finally {
        this.jobStatsLoading = false;
      }
    },
    async loadJobList(page) {
      this.jobListLoading = true;
      const p = page || this.jobPage;

      try {
        const params = { page: p, size: this.jobSize };

        if (this.jobFilterStatus) {
          params.status = this.jobFilterStatus;
        }
        if (this.jobFilterServer) {
          params.server_id = this.jobFilterServer;
        }
        const res = await axios.get("/celery-api/tasks", { params, timeout: 10000 });

        this.jobList  = (res.data.tasks || []).filter(t => t.status !== undefined);
        this.jobTotal = res.data.total || 0;
        this.jobPage  = res.data.page  || p;
      } catch (e) {
        console.warn("[jobmanager] task list 加载失败", e.message);
      } finally {
        this.jobListLoading = false;
      }
    },
    async loadWorkers() {
      try {
        const res = await axios.get("/celery-api/workers", { timeout: 8000 });

        this.knownWorkers = (res.data.workers || []).map(w => w.server_id);
      } catch (e) {
        console.warn("[jobmanager] workers 加载失败", e.message);
      }
    },
    async loadAvailableLists() {
      try {
        const res = await axios.get("/celery-api/domain-lists", { timeout: 8000 });
        const keys = Object.keys(res.data.lists || {});

        if (keys.length > 0) {
          this.availableLists = keys;
        }
      } catch (e) {
        // 保留默认值
      }
    },
    async cancelJob(taskId) {
      try {
        await axios.delete(`/celery-api/tasks/${taskId}`, { timeout: 8000 });
        this.$message.success("任务已取消");
        this.loadJobList(this.jobPage);
        this.loadJobStats();
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.error;

        this.$message.error(msg || "取消失败");
      }
    },
    openSubmitDialog() {
      this.submitForm = this.defaultSubmitForm();
      this.submitDialogVisible = true;
    },
    async doSubmitTask() {
      const type = this.submitForm.task_type || "passive_probe";

      if (type === "passive_probe" && this.submitForm.lists.length === 0) {
        this.$message.warning("Please select at least one domain list");
        return;
      }
      if (type !== "passive_probe" && !this.submitForm.source_run_id.trim()) {
        this.$message.warning("Please enter source passive_probe run_id");
        return;
      }
      this.submitLoading = true;
      try {
        let endpoint = "/celery-api/pipeline/passive-probe";
        const body = { priority: parseInt(this.submitForm.priority, 10) };

        if (this.submitForm.run_id) {
          body.run_id = this.submitForm.run_id;
        }
        if (type === "passive_probe") {
          body.lists = this.submitForm.lists;
          body.concurrency = parseInt(this.submitForm.concurrency, 10);
          body.risk_concurrency = parseInt(this.submitForm.risk_concurrency, 10);
        } else if (type === "active_reverify") {
          endpoint = "/celery-api/pipeline/active-reverify";
          body.source_run_id = this.submitForm.source_run_id.trim();
          body.risk_concurrency = parseInt(this.submitForm.risk_concurrency, 10);
        } else {
          endpoint = "/celery-api/pipeline/ns-backfill";
          body.source_run_id = this.submitForm.source_run_id.trim();
          body.concurrency = parseInt(this.submitForm.concurrency, 10);
        }
        const res = await axios.post(endpoint, body, {
          timeout: 10000,
          headers: { "Content-Type": "application/json" }
        });
        const jobId = res.data.job_id;

        this.$message.info(jobId ? `Submitted, preparing (job: ${jobId.slice(0, 8)}...)` : `Submitted: ${res.data.count || 0} domains`);
        this.submitDialogVisible = false;
        if (jobId) {
          this._pollBatchJob(jobId);
        }
        this.loadJobList(1);
        this.loadJobStats();
      } catch (e) {
        console.error("[doSubmitTask] error:", e.message, "status:", e.response && e.response.status, "data:", JSON.stringify(e.response && e.response.data));
        const msg = e.response && e.response.data && e.response.data.error;

        this.$message.error(msg || "提交失败");
      } finally {
        this.submitLoading = false;
      }
    },
    async _pollBatchJob(jobId) {
      const maxTries = 60;

      for (let i = 0; i < maxTries; i++) {
        await new Promise(r => setTimeout(r, 3000));
        try {
          const res = await axios.get(`/celery-api/batch-submit/status/${jobId}`, { timeout: 5000 });
          const d = res.data;

          if (d.status === "ready") {
            this.$message.success(`提交成功：${d.deduped_domains} 个域名（去重前 ${d.total_domains}），分发给 ${d.worker_count} 台 Worker`);
            this.loadJobList(1);
            this.loadJobStats();
            return;
          }
          if (d.status === "failed") {
            this.$message.error(`提交失败：${d.message || "未知错误"}`);
            return;
          }
        } catch (e) {
          console.warn("[jobmanager] poll batch job error", e.message);
        }
      }
      this.$message.warning("任务准备超时，请刷新页面查看结果");
    },
    async loadScheduleList() {
      this.scheduleLoading = true;
      try {
        const res = await axios.get("/celery-api/scheduled-tasks", { timeout: 8000 });

        this.scheduleList = res.data.scheduled_tasks || [];
      } catch (e) {
        console.warn("[jobmanager] schedule list 加载失败", e.message);
      } finally {
        this.scheduleLoading = false;
      }
    },
    openScheduleDialog() {
      this.scheduleForm = this.defaultScheduleForm();
      this.scheduleDialogVisible = true;
    },
    async doCreateSchedule() {
      if (!this.scheduleForm.name.trim()) {
        this.$message.warning("Please enter schedule name"); return;
      }
      if ((this.scheduleForm.task_type === "passive_probe" || this.scheduleForm.task_type === "pipeline") && this.scheduleForm.lists.length === 0) {
        this.$message.warning("Please select at least one domain list"); return;
      }
      if (!this.scheduleForm.cron.trim()) {
        this.$message.warning("Please enter cron expression"); return;
      }
      this.scheduleSubmitLoading = true;
      try {
        const needsLists = this.scheduleForm.task_type === "passive_probe" || this.scheduleForm.task_type === "pipeline";
        const body = {
          name:     this.scheduleForm.name.trim(),
          task_type: this.scheduleForm.task_type,
          lists:    needsLists ? this.scheduleForm.lists : [],
          priority: parseInt(this.scheduleForm.priority, 10),
          cron:     this.scheduleForm.cron.trim(),
          enabled:  this.scheduleForm.enabled
        };

        if (this.scheduleForm.task_type === "pipeline") {
          body.passive_options = { ...this.scheduleForm.passive_options };
          body.active_options = { ...this.scheduleForm.active_options };
          body.ns_backfill_options = { ...this.scheduleForm.ns_backfill_options };
        }

        if (this.scheduleForm.source_run_id) {
          body.source_run_id = this.scheduleForm.source_run_id.trim();
        }
        await axios.post("/celery-api/scheduled-tasks", body, { timeout: 10000, headers: { "Content-Type": "application/json" } });
        this.$message.success("定时任务创建成功");
        this.scheduleDialogVisible = false;
        this.loadScheduleList();
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.error;

        this.$message.error(msg || "创建失败");
      } finally {
        this.scheduleSubmitLoading = false;
      }
    },
    async toggleScheduleEnabled(row) {
      try {
        await axios.put(`/celery-api/scheduled-tasks/${row.schedule_id}`, { enabled: !row.enabled }, { timeout: 8000, headers: { "Content-Type": "application/json" } });
        row.enabled = !row.enabled;
        this.$message.success(row.enabled ? "已启用" : "已停用");
      } catch (e) {
        this.$message.error("操作失败");
      }
    },
    async triggerSchedule(row) {
      try {
        const res = await axios.post(`/celery-api/scheduled-tasks/${row.schedule_id}/trigger`, {}, { timeout: 10000 });
        const jobId = res.data.job_id;

        this.$message.info(jobId ? `Submitted, preparing (job: ${jobId.slice(0, 8)}...)` : `Submitted: ${res.data.count || 0} domains`);
        if (jobId) {
          this._pollBatchJob(jobId);
        }
        this.loadJobList(1);
        this.loadJobStats();
      } catch (e) {
        const msg = e.response && e.response.data && e.response.data.error;

        this.$message.error(msg || "触发失败");
      }
    },
    async deleteSchedule(row) {
      try {
        await axios.delete(`/celery-api/scheduled-tasks/${row.schedule_id}`, { timeout: 8000 });
        this.$message.success("定时任务已删除");
        this.loadScheduleList();
      } catch (e) {
        this.$message.error("删除失败");
      }
    },
    jobStatusTag(status) {
      const map = { pending: "", running: "warning", passive_running: "warning", active_submitting: "warning", active_running: "warning", ns_backfill_submitting: "warning", ns_backfill_running: "warning", success: "success", partial: "warning", failure: "danger", cancelled: "info" };

      return map[status] || "";
    },
    jobStatusLabel(status) {
      const map = { pending: "待执行", running: "执行中", passive_running: "Passive执行中", active_submitting: "Active提交中", active_running: "Active执行中", ns_backfill_submitting: "NS回填提交中", ns_backfill_running: "NS回填执行中", success: "成功", partial: "部分成功", failure: "失败", cancelled: "已取消" };

      return map[status] || status;
    },
    fmtTime(iso) {
      if (!iso) {
        return "-";
      }
      return iso.replace("T", " ").slice(0, 16);
    },
    fmtElapsed(seconds) {
      if (seconds == null) {
        return "-";
      }
      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);

      if (h > 0) {
        return `${h}h${m}m`;
      }
      if (m > 0) {
        return `${m}m`;
      }
      return `${seconds}s`;
    },
    checkpointText(row) {
      const cp = row.checkpoint || {};
      const total = cp.total || 0;
      const processed = cp.processed || 0;

      if (total > 0) {
        let txt = `${processed.toLocaleString()}/${total.toLocaleString()}`;

        if ((row.requeue_count || 0) > 0) {
          txt += ` · 已恢复${row.requeue_count}次`;
        }
        return txt;
      }
      return row.current_step || "";
    }
  }
};
</script>

<style scoped lang="less">
.jobmanager-container {
  min-height: 100vh;
  background: #0a1628;
  color: #C1D5FF;
  padding-bottom: 90px;
  position: relative;
  overflow: hidden;
  text-align: left;

  .leftSider { position: fixed; left: 0; top: 0; height: 100%; z-index: 1; pointer-events: none; img { height: 100%; } }
  .rightSider { position: fixed; right: 0; top: 0; height: 100%; z-index: 1; pointer-events: none; img { height: 100%; } }
}

.auth-gate {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(10, 22, 40, 0.92);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.auth-card {
  background: #0f2040;
  border: 1px solid rgba(59,130,246,0.3);
  border-radius: 12px;
  padding: 40px 36px;
  width: 360px;
  text-align: center;
  .auth-icon { font-size: 40px; color: #3b82f6; margin-bottom: 12px; }
  .auth-title { font-size: 18px; font-weight: 700; color: #e2eeff; margin-bottom: 8px; }
  .auth-desc { font-size: 13px; color: #7a9cc8; margin-bottom: 20px; }
  .auth-error { font-size: 12px; color: #f87171; margin-bottom: 8px; }
}

.main-content {
  position: relative;
  z-index: 2;
  padding: 0 20px;
}

.section-card {
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.1);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #e2eeff;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
}

.job-stats-bar {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 14px;
  flex-wrap: wrap;
  .job-stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    b { font-size: 22px; font-weight: 700; color: #60a5fa; line-height: 1; }
    span { font-size: 11px; color: rgba(96,165,250,0.6); letter-spacing: 0.5px; }
  }
  .job-stat-sep { width: 1px; height: 28px; background: rgba(96,165,250,0.15); flex-shrink: 0; }
}

.job-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
  .job-list-filters { display: flex; gap: 8px; align-items: center; }
}

.job-id-text { font-family: 'Courier New', monospace; font-size: 12px; color: #60a5fa; cursor: default; }
.job-step-text { font-size: 12px; color: #7a9cc8; }
.scan-task-runid { font-family: 'Courier New', monospace; font-size: 12px; color: #60a5fa; letter-spacing: 0.5px; }

.batch-section-title { color: #7a9cc8; font-size: 12px; margin-bottom: 8px; display: flex; align-items: center; gap: 8px; }
.batch-preset-grid { display: flex; flex-wrap: wrap; gap: 8px 24px; }
.batch-custom-row { display: flex; align-items: flex-start; margin-bottom: 10px; }

/deep/ .el-table {
  background: transparent; color: #C1D5FF;
  th { background: rgba(24,144,255,0.1); color: #fff; font-weight: bold; border-color: rgba(255,255,255,0.1); }
  td { border-color: rgba(255,255,255,0.1); color: rgba(255,255,255,0.85); }
  tr { background: transparent; &:hover > td { background: rgba(24,144,255,0.1) !important; } }
  &::before { display: none; }
  .cell { white-space: normal; word-break: break-word; }
}
/deep/ .el-input__inner {
  background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.15); color: #C1D5FF;
  &::placeholder { color: rgba(193,213,255,0.4); }
  &:focus { border-color: #1890ff; background: rgba(24,144,255,0.08); }
}
/deep/ .el-select {
  .el-input__inner { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.15); color: #C1D5FF; }
}
/deep/ .el-select-dropdown {
  background: #0f2040; border-color: rgba(255,255,255,0.15);
  .el-select-dropdown__item { color: #C1D5FF; &:hover, &.hover { background: rgba(24,144,255,0.15); } &.selected { color: #1890ff; } }
}
/deep/ .el-button {
  &--primary { background: #1890ff; border-color: #1890ff; &:hover { background: #40a9ff; border-color: #40a9ff; } }
  &--default { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.2); color: #C1D5FF; &:hover { background: rgba(255,255,255,0.12); color: #fff; } }
  &--text { color: #60a5fa; &:hover { color: #93c5fd; } }
}
/deep/ .el-checkbox { color: #C1D5FF; .el-checkbox__inner { background: rgba(255,255,255,0.06); border-color: rgba(255,255,255,0.25); } &.is-checked .el-checkbox__inner { background: #1890ff; border-color: #1890ff; } }
/deep/ .el-progress-bar__outer { background: rgba(255,255,255,0.1); }
/deep/ .el-progress-bar__inner { background: #3b82f6; }
/deep/ .el-tag--success { background: rgba(34,197,94,0.15); border-color: rgba(34,197,94,0.3); color: #4ade80; }
/deep/ .el-tag--warning { background: rgba(245,158,11,0.15); border-color: rgba(245,158,11,0.3); color: #fbbf24; }
/deep/ .el-tag--danger  { background: rgba(239,68,68,0.15);  border-color: rgba(239,68,68,0.3);  color: #f87171; }
/deep/ .el-tag--info    { background: rgba(148,163,184,0.1); border-color: rgba(148,163,184,0.2); color: #94a3b8; }
/deep/ .el-tag          { background: rgba(59,130,246,0.15); border-color: rgba(59,130,246,0.3);  color: #60a5fa; }
/deep/ .el-slider__runway { background: rgba(255,255,255,0.1); }
/deep/ .el-slider__bar { background: #1890ff; }
/deep/ .el-slider__button { border-color: #1890ff; background: #0f2040; }
/deep/ .el-switch__core { border-color: rgba(255,255,255,0.2); background: rgba(255,255,255,0.1); }
/deep/ .el-switch.is-checked .el-switch__core { background: #1890ff; border-color: #1890ff; }
/deep/ .job-dialog {
  background: #0f2040; border: 1px solid rgba(255,255,255,0.15); border-radius: 10px;
  .el-dialog__header { border-bottom: 1px solid rgba(255,255,255,0.08); }
  .el-dialog__title { color: #e2eeff; }
  .el-dialog__headerbtn .el-dialog__close { color: #7a9cc8; }
  .el-form-item__label { color: #7a9cc8; }
  .el-dialog__footer { border-top: 1px solid rgba(255,255,255,0.08); }
}
/deep/ .navigation { text-align: center; .nav-item { text-align: center; } }
</style>
